import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { premiumService } from '@/services/api/premium/premium.service'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../queryKeys'

async function getFeatures() {
  const response = await premiumService.getFeatures()
  return response.data
}

export function useGetFeatures() {
  const { isAuthenticated } = useCognitoAuth()

  return useQuery({
    queryKey: [QUERY_KEYS.premium.getFeatures],
    queryFn: getFeatures,
    enabled: isAuthenticated,
  })
}
